import _taggedTemplateLiteral from "/codebuild/output/src756613865/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

import styled from "styled-components";
import { size, typography, mediaQueries, colors } from "../../shared/constants";
import { TertiaryLink } from "../TertiaryLink/index";
var InfoBlock = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: ", ";\n  align-items: ", ";\n  ", " {\n    flex-direction: ", ";\n  }\n"])), function (e) {
  return "small" === e.size ? "row" : "column";
}, function (e) {
  return "small" === e.size ? "flex-start" : "center";
}, mediaQueries.forTabletHorizontalUp, function (e) {
  return "xlarge" === e.size ? "column" : "row";
}),
    ImageWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  margin-bottom: ", "px;\n  margin-right: ", "px;\n  ", " {\n    margin-bottom: ", "px;\n    margin-right: ", "px;\n  }\n"])), function (e) {
  return {
    xlarge: size.xl1,
    large: size.md,
    small: "0"
  }[e.size];
}, function (e) {
  return "small" === e.size ? size.md : "0";
}, mediaQueries.forTabletHorizontalUp, function (e) {
  return "xlarge" === e.size ? size.xl1 : "0";
}, function (e) {
  return {
    xlarge: 0,
    large: size.xl1,
    small: size.md
  }[e.size];
}),
    ImageContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  height: ", ";\n  width: ", ";\n  display: flex;\n  flex: 0 0 auto;\n  justify-content: center;\n  overflow: hidden;\n  background-color: ", ";\n  align-items: center;\n  ", "\n  ", " {\n    ", "\n  }\n"])), function (e) {
  return {
    xlarge: "227px",
    large: "160px",
    small: "56px"
  }[e.size];
}, function (e) {
  return {
    xlarge: "227px",
    large: "160px",
    small: "56px"
  }[e.size];
}, function (e) {
  return e.isComponent ? colors.teal1 : "transparent";
}, function (e) {
  return e.isComponent ? "& > * {width: ".concat(size.xl1, "px; height: ").concat(size.xl1, "px}") : null;
}, mediaQueries.forTabletHorizontalUp, function (e) {
  return "xlarge" === e.size ? "height: 160px; width: 160px;" : null;
}),
    Image = styled.img(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  flex: 0 0 auto;\n  height: 100%;\n"]))),
    ContentContainer = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  text-align: ", ";\n  ", " {\n    text-align: ", ";\n  }\n"])), function (e) {
  return "small" === e.size ? "left" : "center";
}, mediaQueries.forTabletHorizontalUp, function (e) {
  return "xlarge" === e.size ? "center" : "left";
}),
    Title = styled.h3(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", "\n  margin-bottom: ", "px;\n"])), typography.subtitle, function (e) {
  return "large" === e.size ? size.xs3 : size.xs2;
}),
    Content = styled.p(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
  return "large" === e.size ? typography.bodyText : typography.bodyTextSmall;
}),
    NumberTag = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: ", ";\n  border-radius: 50%;\n  color: ", ";\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  height: 45px;\n  width: 45px;\n  transform: translate(-50%, 50%);\n"])), typography.buttonText, colors.blue1, colors.white),
    CTA = styled(TertiaryLink)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  margin: ", "px 0;\n  color: ", ";\n"])), size.sm, colors.green5);
export { InfoBlock, ImageWrapper, ImageContainer, Image, ContentContainer, Title, Content, NumberTag, CTA };